import Constants from "~/helpers/enums/Constants";
import meServices from "~/services/meServices";

export const setMe = (token = null) => (dispatch) => {
	const config = token ? {
		headers: {
			Authorization: `Bearer ${token}`
		},
	} : undefined;

	meServices.getMe(config)
	  .then(({ data }) => {
		if (data) {
			localStorage.setItem("@prit-web/meData", JSON.stringify(data));
			localStorage.setItem("@prit-web/userId", data?.id);
		}
		dispatch({ type: Constants.ME, payload: { me: data } });
	  })
	  .catch((error) => {
		alert("Ocorreu um erro no ME " + error.message);
	  });
		
};
export default { setMe };
